import { InputNumberValueChangeParams } from 'primereact/inputnumber';
import { useId } from 'react-id-generator';
import BeeCurrencyInput from './BeeCurrencyInput';
import BeeErrorLabel from './BeeErrorLabel';
import BeeInfoLabel from './BeeInfoLabel';

import './BeeValidatedCurrencyInput.scss';

type BeeValidatedCurrencyInputProps = {
  id?: string;
  label?: string;
  errorLabel?: string | null;
  neutralLabel?: string | null;
  validLabel?: string | null;
  value?: number;
  minFractionDigits?: number;
  maxFractionDigits?: number;
  disabled?: boolean;
  formstate?: string;
  readOnly?: boolean;
  required?: boolean;
  onChange?: (e: InputNumberValueChangeParams) => void;
  onFocusOut?: (e: number | undefined) => void;
};

export function BeeValidatedCurrencyInput({
  label,
  errorLabel,
  neutralLabel,
  validLabel,
  value,
  disabled,
  minFractionDigits,
  maxFractionDigits,
  formstate,
  readOnly,
  required,
  onChange,
  onFocusOut
}: BeeValidatedCurrencyInputProps) {
  const currentId = useId(1, 'bee-val-cur-input-')[0];

  // classNames
  const labelClassNames = 'bee-validated-cur-input';

  const textSize = 'medium';
  const inputFormstate = formstate === 'none' ? 'neutral' : formstate;

  function change(e: InputNumberValueChangeParams) {
    if (!disabled && onChange) {
      onChange(e);
    }
  }
  function focusOut(e: number | undefined) {
    if (!disabled && onFocusOut) {
      onFocusOut(e);
    }
  }

  const renderLabel = () => {
    return (
      <div className={labelClassNames}>
        {formstate === 'error' && errorLabel ? (
          <BeeErrorLabel size={textSize} label={errorLabel} visible={true} />
        ) : formstate === 'valid' && validLabel ? (
          <BeeInfoLabel
            size={textSize}
            label={validLabel}
            type={'valid'}
            visible={true}
          />
        ) : formstate === 'neutral' && neutralLabel ? (
          <BeeInfoLabel
            size={textSize}
            label={neutralLabel}
            type={'neutral'}
            visible={true}
          />
        ) : null}
      </div>
    );
  };
  return (
    <div id={currentId}>
      <BeeCurrencyInput
        label={label}
        value={value}
        disabled={disabled}
        minFractionDigits={minFractionDigits}
        maxFractionDigits={maxFractionDigits}
        formstate={inputFormstate}
        readOnly={readOnly}
        required={required}
        onChange={(e) => change(e)}
        onFocusOut={(e) => focusOut(e)}
      />
      {formstate !== 'none' && (errorLabel || neutralLabel || validLabel)
        ? renderLabel()
        : null}
    </div>
  );
}

export default BeeValidatedCurrencyInput;
